import { render, staticRenderFns } from "./FieldType.vue?vue&type=template&id=0af2e27c&"
import script from "./FieldType.vue?vue&type=script&lang=js&"
export * from "./FieldType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports